import { KeyValue } from '@angular/common';
import { AfterViewInit, ElementRef, OnInit, ViewChild } from '@angular/core';

import { EMPTY, Observable, Subject } from 'rxjs';
import { catchError, debounceTime, finalize, switchMap } from 'rxjs/operators';

import { ControlValidatorService } from '../services/control-validator.service';
import { ControlShared, translateControl2ControlDataModel, isEmptyInputValue } from '../utils';
import { getCascadeParentControlsValue } from '../utils/cascade-helper';
import { ControlModelPropertyEnum } from './control-model-property';
import { ControlBroadCastEventName } from './control-type-name';
import {
  AbstractControl,
  CascadeParentValue,
  CascadeParentValueNotification,
  ControlDataModel,
  ControlEvent,
  ControlViewModel,
  ValueControlViewModel,
  ControlOperateMode,
  OptionProperty
} from './control.types';
import { DynamicFormDataConfig } from './designer.types';
import {
  ControlValidateMoment,
  ControlValidator,
  ControlValidatorAsync,
  ControlValidatorBase,
  ControlValidatorModel
} from './validator.types';

/**
 * å¸¦å¼æ§ä»¶åºç±»
 */
// @Injectable()
export class AbstractValueControlBase<T extends ValueControlViewModel>
  implements AbstractControl<T>, OnInit, AfterViewInit, CascadeParentValueNotification {
  /**
   * @description å­æ§ä»¶
   *
   * @memberof AbstractValueControlBase
   */
  children: AbstractValueControlBase<T>[];
  parent: AbstractControl<ControlViewModel>;

  /**
   * @description æ§ä»¶ç±»å
   *
   * @memberof AbstractValueControlBase
   */
  type: string;

  /**
   * @description æ¯å¦æ¯è®¾è®¡æ¶
   *
   * @memberof AbstractValueControlBase
   */
  isDesign: boolean;

  /**
   * @description æ§ä»¶model
   *
   * @memberof AbstractValueControlBase
   */
  model: T;

  /**
   * @description æ°æ®éç½®ä¿¡æ¯
   *
   * @memberof AbstractValueControlBase
   */
  dataConfig: DynamicFormDataConfig;

  /**
   * @description æ¯å¦å®¹å¨
   *
   * @memberof AbstractValueControlBase
   */
  isContainer: boolean;

  /**
   * @description ä»æ¥ç
   *
   * @memberof AbstractValueControlBase
   */
  viewOnly: boolean;

  /**
   * @description å¯ç¨æ¥çæ¶ç¼è¾
   *
   * @memberof AbstractValueControlBase
   */
  enableEditAtView: boolean;

  /**
   * @description å¯ç¨æ¥çæ¶ç¼è¾çæ§ä»¶åç§°åè¡¨
   *
   * @memberof AbstractValueControlBase
   */
  enableEditNameList?: string[];
  /**
   * @description èªå®ä¹äºä»¶åç§°ï¼å¦æè¦æèªå®ä¹äºä»¶éè¦æ¹åè¿ä¸ªå­æ®µå¼
   *
   * @memberof AbstractValueControlBase
   */
  customEventNames: Array<string>;

  /**
   * @description èªå®ä¹äºä»¶
   *
   * @memberof AbstractValueControlBase
   */
  customEvents: Array<KeyValue<string, Function>>;

  /**
   * @description éªè¯å¨
   *
   * @memberof AbstractValueControlBase
   */
  validators: Array<ControlValidatorBase>;

  /**
   * @description æ§ä»¶å±äº«
   *
   */
  controlShared: ControlShared;

  hidden: boolean;
  /**
   * @description å¼æ¹å
   * å³èççº§èæ§ä»¶
   */
  cascadeControls: AbstractValueControlBase<any>[] = [];

  /**
   * æ§ä»¶æ¨¡å¼
   */
  operateMode: ControlOperateMode = ControlOperateMode.Initial;

  /**
   * @description çº§èå¼æ¹å
   *
   */
  get valueChanged$() {
    // breakChangeï¼ cascadeValueChanged ä¿®æ¹ä¸º valueChanged$
    return this._valueChanged.asObservable();
  }

  /**
   * çº§èååäºä»¶
   */
  get cascadeValueChanged$() {
    return this._cascadeValueChanged.asObservable();
  }

  /**
   * @description å¨é¨æ ¡éªå®æ
   *
   */
  get statusChanges$() {
    return this._statusChanges.asObservable();
  }
  /**
   * æ¯å¦ææï¼å½æ§ä»¶éªè¯å¨é½éªè¯éè¿ è¿åtrue
   *
   * @readonly
   * @memberof AbstractValueControlBase
   */
  get valid(): boolean {
    return this.getValidState();
  }

  get designHostClass(): string {
    return '';
  }

  /**
   * æ¯å¦åªè¯»
   */
  get readonly(): boolean {
    // æ¥çæ¨¡å¼ï¼viewOnly/model.readonly ä¸ºçæ¶ï¼è¥è¡¨å enableEditAtView ä¸æ§ä»¶ model.enableEditAtView ä¸ºçåå¯ç¼è¾ï¼
    // enableEditNameList éç©ºæ¶ä»åååæ§ä»¶å¯ç¼è¾ï¼ååä¸ºç©ºæ¶ä¸æååè¿æ»¤ï¼ä»¥ model.enableEditAtView ä¸ºåã
    const baseReadonly = this.viewOnly || this.model.readonly;
    const formAndModel = this.enableEditAtView && this.model.enableEditAtView;
    const list = this.enableEditNameList;
    const allowEditInView =
      formAndModel && (!list || list.length === 0 || list.includes(this.model.name));
    return baseReadonly && !allowEditInView;
  }

  /**
   * å±æ§å¼åçååäºä»¶
   */
  get propertyValueChanged$(): Observable<{ name: string; value: any }> {
    return this._propertyValueChanged.asObservable();
  }

  /**
   * æ ¹æ®Urlè·åçº§èæ°æ®å¯è§å¯å¯¹è±¡
   *
   */
  cascadeDataByUrl$ = new Subject<CascadeParentValue[]>();

  @ViewChild(`valueElement`) valueElement: ElementRef<any>;

  // å¼æ­¥éªè¯å¨éªè¯ä¸­çä¸ªæ°
  private asyncValidatorPendingCount: number = 0;
  private _valueChanged: Subject<T> = new Subject<T>();
  private _statusChanges: Subject<boolean> = new Subject<boolean>();
  private _propertyValueChanged: Subject<{ name: string; value: any }> = new Subject<{ name: string; value: any }>();
  private _cascadeValueChanged: Subject<T> = new Subject<T>();

  constructor() {
    this.dataConfig = { formCode: '', targetId: '' };
  }

  /**
   * å±æ§å¼åå
   * @param name å±æ§åç§°
   * @param value å±æ§å¼
   */
  propertyValueChanged(name: string, value: any): void {
    this._propertyValueChanged.next({ name, value });
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    // ç¨æ¥è§£å³è®¾ç½®é»è®¤å¼åè§¦ååæ­¥éªè¯é æçlifecycleæ¥é
    Promise.resolve().then(() => {
      this.setModelDefaultValue();
    });

    this.bindEvents();
    this.bindCascadeDataByUrl();
  }

  /**
   * å·æ°é»è®¤å¼
   * @memberof AbstractValueControlBase
   */
  refreshModelDefaultValue(force?: boolean) {
    const propertyName = ControlModelPropertyEnum.DefaultValue;
    let propertyValue: OptionProperty[] = this.model[propertyName];
    if (!propertyValue) {
      // å¼å®¹èçæ¬é»è®¤å¼è®¾ç½®æ¹å¼
      propertyValue = [{ id: 'custom', selected: true, value: undefined, text: undefined }];
    }
    const option = propertyValue.find((s: any) => s.selected === true);

    if (option.id === 'custom') {
      if (!force && isEmptyInputValue(option.value)) {
        // ä¸å¼ºå¶æ¸ç©ºå¼çæåµä¸ï¼å¦æé»è®¤å¼æ¯ç©ºå¼çè¯ä¸ç¨å¤çï¼å¦åä¼é ææ²¡æè®¾ç½®é»è®¤å¼ï¼ä½æ¯ä¼è§¦åäºçº§è
        return;
      }
      // è®¾è®¡æ¶ï¼éè¦å¼ºå¶æ¸é¤modelçvalueå¼ï¼å¦åä¼ä¸ç´å­å¨
      if (force) {
        this.model.value = undefined;
      }
      option.value = option.value || this.model.value;

      this.setModelValue(option.value);
      this.validate();
      this.broadControlValueChange();
    } else {
      if (isEmptyInputValue(option.value)) {
        return;
      }

      this.controlShared.remoteDataSourceService.getDefaultValueByProperty(option, '').subscribe(
        (res: any) => {
          this.setModelValue(res);
          this.validate();
          this.broadControlValueChange();
        },
        (error: any) => {
          this.controlShared.commonConfig.log.warn('è·åæ°æ®å¤±è´¥');
        }
      );
    }
  }

  /**
   * è®¾ç½®é»è®¤å¼
   * @memberof AbstractValueControlBase
   */
  setModelDefaultValue() {
    if (this.operateMode === ControlOperateMode.Add) {
      this.refreshModelDefaultValue();
    }
    // // éè¿targetIdå¤æ­æ¯å¦æ¯ç¼è¾ç¶æï¼å¦ææ¯ç¼è¾ç¶æï¼åä¸è®¾ç½®é»è®¤å¼
    // if (this.dataConfig.targetId && this.mode !== ControlMode.Add) {
    //   return;
    // }
    // this.refreshModelDefaultValue();
  }

  /**
   * é»è®¤å¼åçæ¹å
   * @memberof AbstractValueControlBase
   */
  defaultValueChange(): void {
    this.refreshModelDefaultValue(true);
  }

  /**
   * è·åç¶çº§æ§ä»¶çå¼
   * @returns ç¶çº§æ§ä»¶çå¼
   * @memberof AbstractValueControlBase
   */
  getCascadeValue(values: CascadeParentValue[]): any {
    return getCascadeParentControlsValue(values);
  }

  /**
   * ç»å®æ ¹æ®Urlè·åçº§èæ°æ®
   * è¿æ ·æ¯ä¸ºäºé¿åå ä¸ºå¤æ¬¡httpè¯·æ±ï¼åè¯·æ±çåæ¥é ææ°æ®ä¸ä¸è´
   */
  bindCascadeDataByUrl() {
    const debounceDueTime = this.getCascadeDataByUrlDebounceDueTime();
    this.cascadeDataByUrl$
      .pipe(
        debounceTime(debounceDueTime),
        switchMap((values) => {
          try {
            const url = this.controlShared.remoteDataSourceService.getUrlByCascade(
              this,
              values,
              this.model.cascadeParentName[1].value
            );
            return this.controlShared.remoteDataSourceService.getDataByUrl(url).pipe(
              catchError(() => {
                this.controlShared.commonConfig.log.warn('è·åæ°æ®å¤±è´¥');
                return EMPTY;
              })
            );
          } catch (error) {
            console.error(error);
            return EMPTY;
          }
        })
      )
      .subscribe(
        (res: any) => {
          if (!res) {
            return;
          }
          const valueMember = 'data';
          const value = res[valueMember];
          this.setModelValue(value);
          this.validate();
          this.broadControlValueChange();
        },
        (error: any) => { }
      );
  }

  /**
   * ç¶çº§æ§ä»¶å¼åçæ¹åæ¶æ§è¡
   * @param values ç¶çº§æ§ä»¶æ°ç»
   */
  onCascadeParentValueChange(values: CascadeParentValue[]): void {
    if (this.model.cascadeParentName && this.model.cascadeParentName[1].value) {
      this.cascadeDataByUrl$.next(values);
    } else {
      const value = this.getCascadeValue(values);
      this.setModelValue(value);
      this.validate();
      this.broadControlValueChange();
    }
  }

  /**
   * è§¦åé»è®¤çº§èåå
   */
  onDefaultCascadeValueChange() {
    if (this.model && this.model.defaultTriggerCascade) {
      this._cascadeValueChanged.next(this.model);
    }
  }

  /**
   * æ¯å¦ææï¼å½æ§ä»¶éªè¯å¨é½éªè¯éè¿ è¿åtrue
   *
   * @returns  å½æ§ä»¶éªè¯å¨é½éªè¯éè¿ è¿åtrue å¦åfalse
   * @memberof AbstractValueControlBase
   */
  getValidState(): boolean {
    if (!this.validators || this.viewOnly) {
      return true;
    }
    if (this.asyncValidatorPendingCount !== 0) {
      return false;
    }
    let result = true;
    this.validators.forEach((s) => {
      if (s.error) {
        if (!s.error.success) {
          result = false;
          return;
        }
      }
    });
    return result;
  }

  /**
   * @description è·åæ§ä»¶çDataModel
   *
   * @returns æ§ä»¶çDataModel
   * @memberof AbstractValueControlBase
   */
  getDataModel(): ControlDataModel {
    return translateControl2ControlDataModel(this);
  }

  /**
   * @description è®¾ç½®æ§ä»¶modelçvalueå¼
   *
   * @param value æ§ä»¶modelçvalue
   * @memberof AbstractValueControlBase
   */
  setModelValue(value: any): void {
    this.model[`value`] = value;
  }
  /**
   * @description è®¾ç½®modeçvalueå¼
   *
   * @returns modeçvalueå¼
   * @memberof AbstractValueControlBase
   */
  getModelValue(): any {
    return this.model[`value`];
  }

  /**
   * @description ç»å®æ§ä»¶äºä»¶å°é»è®¤åç´ ä¸
   *
   * @memberof AbstractValueControlBase
   */
  bindEvents(): void {
    // this.valueElement = this.getChildrenByPosition(this.element.nativeElement, 0, 1);
    this.bindEventsToEl(this.valueElement ? this.valueElement.nativeElement : undefined);
  }

  /**
   * @description æ ¹æ®å±çº§è·ååç´ çå­åç´ ï¼positionæ¥åä¸ä¸ªæ°ç»ï¼å¯ä»¥å¤å±çº§åµå¥
   * ä¾å¦ç¬¬ä¸ä¸ªåç´ çç¬¬äºä¸ªå­©å­å¯ä»¥è¡¨ç¤ºä¸º getChildrenByPosition(element, 0, 1)
   * ä¹å¯ä»¥ getChildrenByPosition(element, [0,1])
   * @param  element ç¶åç´ 
   * @param  position ä½ç½®æ°ç»
   * @returns ç­éåºçåç´ 
   * @memberof AbstractValueControlBase
   */
  getChildrenByPosition(element: any, ...position: number[]): any {
    let children = element;
    for (let i = 0; i < position.length; i++) {
      children = this.getElementChildren(children)[position[i]];
    }
    return children;
  }

  /**
   * @description ç»å®æ§ä»¶äºä»¶äºä»¶å°åç´ 
   *
   * @param element è¦ç»å®å°çåç´ 
   * @returns
   * @memberof AbstractValueControlBase
   */
  bindEventsToEl(element?: any) {
    if (!this.model[`events`]) {
      return;
    }
    const events = this.model[`events`];
    events.forEach((event: ControlEvent) => {
      if (!event || !event.name || !event.script) {
        return;
      }

      if (this.addToCustomEvent(event)) {
        return;
      }
      // é»è®¤ç»å®å°åç´ ä¸
      if (element) {
        const func = new Function(event.script);
        (element as HTMLElement).addEventListener(event.name, (evt: Event) => {
          func(evt);
        });
      }
    });
  }

  /**
   * @description è°ç¨æ§ä»¶äºä»¶ï¼ä¸è¬åªææèªå®ä¹äºä»¶çæ¶åæéè¦
   *
   * @param name äºä»¶çåç§°
   * @memberof AbstractValueControlBase
   */
  callEvent(name: string, thisArg?: any, ...argArray: any[]) {
    if (!this.customEvents) {
      return;
    }
    const event = this.customEvents.filter((s) => s.key === name);
    if (event) {
      event.forEach((s) => {
        if (s.value) {
          s.value.call(this, thisArg, argArray);
        }
      });
    }
  }

  /**
   * @description è·åæ§ä»¶çéªè¯å¨ï¼æ ¹æ®æ§ä»¶modelä¸­çéªè¯å¨è®¾ç½®è·åéªè¯å¨
   *
   * @returns éªè¯å¨éå
   * @memberof AbstractValueControlBase
   */
  getValidators(controlValidatorService: ControlValidatorService): Array<ControlValidatorBase> {
    if (!this.model.validators) {
      this.model.validators = {};
    }
    const validators = new Array<ControlValidatorBase>();
    const validatorModels = this.model.validators;
    if (!validatorModels) {
      return validators;
    }

    for (const field of Object.keys(validatorModels)) {
      // æ²¡æéä¸­çå°±ä¸çæéªè¯å¨
      const model = <ControlValidatorModel<any>>validatorModels[field];
      if (model && model.required) {
        const validator = controlValidatorService.getControlValidator(field, this, model.data);
        if (validator) {
          validators.push(validator);
        }
      }
    }

    return validators;
  }

  /**
   * @description éªè¯ææéªè¯å¨
   *
   * @returns
   * @memberof AbstractValueControlBase
   */
  validate() {
    // æ ¡éªéªè¯å¨
    if (!this.validators) {
      return;
    }
    this.validateAtMoment(undefined);
  }

  /**
   * @description æ ¹æ®éªè¯å¨çéªè¯æ¶å»ï¼éªè¯éªè¯å¨ã
   * éªè¯å¨ä¼å¨éªè¯å®åæ­¥éªè¯å¨åï¼æä¼éªè¯å¼æ­¥éªè¯å¨ãå¦ææåæ­¥éªè¯å¨éªè¯ä¸éè¿ï¼å¼æ­¥éªè¯å¨ä¹ä¸ä¼éªè¯
   * @param  validatorMoment éªè¯æ¶å»
   * @returns
   * @memberof AbstractValueControlBase
   */
  validateAtMoment(validatorMoment: ControlValidateMoment) {
    if (!this.validators || this.validators.length <= 0) {
      return;
    }

    let success = true;
    // æ§è¡åæ­¥éªè¯å¨
    const controlValidators = this.validators.filter(
      (s) => (!validatorMoment || s.validateMoment === validatorMoment) && s instanceof ControlValidator
    );
    controlValidators.forEach((s: ControlValidator) => {
      const result = s.validate();
      if (!result.success) {
        success = false;
      }
    });
    this.stateChanged(this.valid);

    if (!success) {
      return;
    }

    // åæ­¥æ§è¡å®æåï¼æ§è¡å¼æ­¥éªè¯å¨
    const controlAsyncValidators = this.validators.filter(
      (s) => (!validatorMoment || s.validateMoment === validatorMoment) && s instanceof ControlValidatorAsync
    );
    // asyncValidator count pending when validate
    controlAsyncValidators.forEach((s: ControlValidatorAsync) => {
      this.asyncValidatorPendingCount++;
      s.validateAsync()
        .pipe(
          finalize(() => {
            this.asyncValidatorPendingCount--;
            if (this.asyncValidatorPendingCount === 0) {
              this.stateChanged(this.valid);
            }
          })
        )
        .subscribe((m) => { });
    });
    if (this.asyncValidatorPendingCount > 0) {
      this.stateChanged(this.valid);
    }
  }

  /**
   * å¹¿æ­æ§ä»¶å¼æ¹å
   *
   * @memberof AbstractValueControlBase
   */
  broadControlValueChange(broadCascadeValueChange: boolean = true) {
    this.broadValueChange();
    if (broadCascadeValueChange) {
      this._cascadeValueChanged.next(this.model);
    }
    this.broadControlBroadCast(ControlBroadCastEventName.valueChange, this.model.value);
  }
  /**
   * å¹¿æ­æ§ä»¶å¹¿æ­äºä»¶
   *
   */
  broadControlBroadCast(name: string, value: any) {
    if (!this.model || !this.model.isBroadCastEvent) {
      return;
    }
    Promise.resolve().then(() => {
      this.controlShared.controlBroadCasted({
        name: name,
        controlName: this.model.name,
        value: value,
        control: this
      });
    });
  }

  /**
   *
   * åéå¼æ¹å
   */
  broadValueChange() {
    this._valueChanged.next(this.model);
  }

  /**
   *
   * æ§ä»¶å®æå¨é¨æ ¡éª
   */
  stateChanged(valid: boolean) {
    this._statusChanges.next(valid);
  }

  /**
   * è§¦åå¼æ¹åäºä»¶ï¼å¹¿æ­ï¼
   *
   */
  valueChange(event?: any) {
    this.broadControlValueChange();
  }

  /**
   * è·åå³èé»è®¤å®ä½å±æ§å¼
   */
  getDefaultEntityAttribute(): string {
    if (!this.model.associatedEntityAttributes) {
      return '';
    }
    const defaultAttribute = this.model.associatedEntityAttributes.find((s) => !s.source);
    if (defaultAttribute) {
      return defaultAttribute.target;
    }
    return '';
  }

  /**
   * @description å¤çä¸æ¯ç¨angularæ¹å¼çå¼æ¹åãå½æä»¬ç¨å¶ä»ç¬¬ä¸æ¹æ¹å¼æ¹åäºåç´ çdomå¼åï¼angularææä¸å°ä¿®æ¹åçå¼ã
   * ä¸ºäºé¿åä¸¤è¾¹æ°æ®ä¸ä¸è´ï¼è¿ä¸ªæ¶åå°±éè¦å°domä¸­çå¼åç»å®çåç´ çangularçmodelå¼è¿è¡åæ­¥ã
   * @memberof AbstractValueControlBase
   */
  protected handleValueChangeNotByAngularWay() {
    if (this.valueElement) {
      return;
    }
    if (!this.isEqual(this.valueElement.nativeElement.value, this.model.value)) {
      setTimeout(() => {
        const val = this.valueElement.nativeElement.value;
        if (!this.isEqual(val, this.model.value)) {
          this.model.value = val;
        }
      }, 0);
      // this.valueElement.nativeElement.dispatchEvent(new Event('input'));
    }
  }

  /**
   * @description è¿ååç´ çå­©å­èç¹
   *
   * @param element ç¶åç´ 
   * @returns å­èç¹éå
   * @memberof AbstractValueControlBase
   */
  private getElementChildren(element: any): any {
    return element[`children`];
  }

  /**
   * @description å¤æ­ä¸¤ä¸ªå¼æ¯å¦ç¸ç­ï¼å¤çäºå½modelValueæ¯numberçæåµä¸å¼æ¯å¯¹ä¸æ­£ç¡®çæåµ
   *
   * @param  value
   * @param  modelValue
   * @returns æ¯å¦ç¸ç­ trueç¸ç­ï¼falseä¸ç­
   * @memberof AbstractValueControlBase
   */
  private isEqual(value: string, modelValue: any): boolean {
    if (!value) {
      if (modelValue === undefined || modelValue === null) {
        return true;
      }
    }
    if (typeof modelValue === 'number') {
      return Number(value) === modelValue;
    }
    return value === modelValue;
  }
  /**
   * @description å°æ§ä»¶äºä»¶æ·»å å°èªå®ä¹äºä»¶ï¼è¿ä¸ªæ¯è¦ç¨èªå®ä¹äºä»¶çæ¶åä½¿ç¨
   *
   * @param  event æ§ä»¶äºä»¶
   * @returns æ¯å¦æ·»å æå
   * @memberof AbstractValueControlBase
   */
  private addToCustomEvent(event: ControlEvent): boolean {
    let isCustom = false;
    if (!this.customEventNames) {
      return isCustom;
    }

    const name = this.customEventNames.find((s) => s === event.name);
    if (!name) {
      return isCustom;
    }

    if (!this.customEvents) {
      this.customEvents = [];
    }

    this.customEvents.push({ key: name, value: new Function(event.script) });
    isCustom = true;
    return isCustom;
  }

  /**
   * è·åçº§èæ ¹æ®urlåå¼é²ææ¶é´ é»è®¤50ms
   * ç»ä»¶æ¬èº«çéç½®-ãå¨å±éç½®-ãé»è®¤å¼å¼
   */
  private getCascadeDataByUrlDebounceDueTime(): number {
    if (this.model.cascadeDataByUrlDebounceDueTime || this.model.cascadeDataByUrlDebounceDueTime === 0) {
      return this.model.cascadeDataByUrlDebounceDueTime;
    }

    const configCascadeDataByUrlDebounceDueTime = this.controlShared.designerConfig.cascadeDataByUrlDebounceDueTime;
    if (configCascadeDataByUrlDebounceDueTime || configCascadeDataByUrlDebounceDueTime === 0) {
      return configCascadeDataByUrlDebounceDueTime;
    }
    return 50;
  }
}
